import React from "react";
import {
  Card,
  CardBody,
  CardHeader
} from "../../../../../_metronic/_partials/controls";
import { organizationInstructionList } from "../../../../config/helper";

export default function InstructionList() {
  return (
    <>
      <Card>
        <CardHeader title="Instruksi Kelengkapan Data" />
        <CardBody>
          <ol>
            {/* {organizationInstructionList.map(instruction => (
              <li style={{ margin: "5px 0", fontSize: 14 }}>{instruction}</li>
            ))} */}
            <li>
              <strong>Surat pengajuan</strong> menjadi MPZ
            </li>
            <li>
              Mengisi <strong>form profile</strong> mitra
            </li>
            <li>
              Melampirkan <strong>scan KTP</strong> 3 orang pengurus inti
              (Ketua, Sekretaris, Bendahara)
            </li>
            <li>
              Melampirkan <strong>laporan keuangan</strong> bulanan tahun
              terakhir
            </li>
            <li>
              Melampirkan <strong>strukur pengurus</strong> mitra dan LAZnya
              (bila LAZ menjadi unit tersendiri)
            </li>
            <li>
              Melampirkan <strong>form pemahaman</strong> dan persetujuan
            </li>
          </ol>
        </CardBody>
      </Card>
    </>
  );
}
